export default "__VITE_ASSET__ZAAER93P__"